import React from "react";

const OwnerDetails = ({ details }) => {
  return (
    <div className="user-detail-table">
      <table className="tabledetails table-borderless user-det w-100 mb-5">
        <thead>
          <th colspan="3" className="h8 mb-0 font-weight-light p-3">
            BASIC DETAILS
          </th>
        </thead>
        <tbody>
          <tr>
            <td style={{ width: "40%" }}>Property Owner Id</td>
            <td>:</td>
            <td>{details?.owner?.owner_id}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Name</td>
            <td>:</td>
            <td>{details?.owner?.name}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>E-mail ID</td>
            <td>:</td>
            <td>{details?.owner?.email}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Mobile Number*</td>
            <td>:</td>
            <td>{details?.owner?.mobile}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Contact Number1</td>
            <td>:</td>
            <td>{details?.owner?.contact_number_1}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Contact Number2</td>
            <td>:</td>
            <td>{details?.owner?.contact_number_2}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>City</td>
            <td>:</td>
            <td>{details?.owner?.city?.name}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>State</td>
            <td>:</td>
            <td>{details?.owner?.state?.name}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Area</td>
            <td>:</td>
            <td>{details?.owner?.location?.name}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Street</td>
            <td>:</td>
            <td>{details?.owner?.street}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Appartment</td>
            <td>:</td>
            <td>{details?.owner?.apartment}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Block Floor</td>
            <td>:</td>
            <td>{details?.owner?.street}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Street</td>
            <td>:</td>
            <td>{details?.owner?.block_no}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Door No</td>
            <td>:</td>
            <td>{details?.owner?.door_no}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Pincode</td>
            <td>:</td>
            <td>{details?.owner?.pin_code}</td>
          </tr>

          <tr class="bg-purple p-2 rounded my-2">
            <td colspan="3" class="h8_2 mb-0 font-weight-light p-3">
              GST Details
            </td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Gst Name</td>
            <td>:</td>
            <td>{details?.owner?.gst_entity_name}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Gst Number</td>
            <td>:</td>
            <td>{details?.owner?.gst_number}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Gst Address</td>
            <td>:</td>
            <td>{details?.owner?.gst_address}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Gst Contact Email</td>
            <td>:</td>
            <td>{details?.owner?.gst_contact_email}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Gst Contact Number</td>
            <td>:</td>
            <td>{details?.owner?.gst_contact_number}</td>
          </tr>
          <tr class="bg-purple p-2 rounded my-2">
            <td colspan="3" class="h8_2 mb-0 font-weight-light p-3">
              Bank Details
            </td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Bank Name</td>
            <td>:</td>
            <td>{details?.owner?.bank?.bank_name}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Bank Branch</td>
            <td>:</td>
            <td>{details?.owner?.bank?.branch}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Account Holder Name</td>
            <td>:</td>
            <td>{details?.owner?.bank?.account_holder_name}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Account No</td>
            <td>:</td>
            <td>{details?.owner?.bank?.account_number}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Ifsc Code</td>
            <td>:</td>
            <td>{details?.owner?.bank?.ifsc_code}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Upi Id</td>
            <td>:</td>
            <td>{details?.owner?.bank?.upi_id}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Gpay Number</td>
            <td>:</td>
            <td>{details?.owner?.bank?.gpay_number}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Phone Pay Number</td>
            <td>:</td>
            <td>{details?.owner?.bank?.phonepe_number}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default OwnerDetails;
